import { memo } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

function Logo({ single = false, sx }) {
  const theme = useTheme();

  const PRIMARY_MAIN = theme.palette.primary.main;

  const singleLogo = (
    <svg
      width="104"
      height="107"
      viewBox="0 0 104 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="104" height="107" fill="#1E1E1E" />
      <g id="Home" clip-path="url(#clip0_1_10)">
        <rect width="1920" height="3649" transform="translate(-908 -3431)" fill="white" />
        <path
          id="Rectangle 92"
          d="M-908 -340C-908 -413.454 -848.454 -473 -775 -473H1012V225H-908V-340Z"
          fill="#2E428B"
        />
        <g id="Group 101">
          <path
            id="Vector"
            d="M67.566 8.37295C39.7889 -13.0013 4.5044 11.4181 0 27.457V73.885C7.20704 89.1524 23.0225 95.1421 30.0294 95.3967C28.5279 98.5924 27.7771 100.85 27.7771 103.861C27.7771 106.241 30.0294 107.61 30.7801 105.32C31.3807 103.488 32.0313 102.012 32.2816 101.504C35.8851 94.1752 44.2933 96.16 50.2992 97.6867C61.7103 100.74 72.5709 104.964 76.5748 107H94.5925C98.1599 103.977 98.6009 103.523 101.397 99.1678L102.1 97.8396C104.524 92.7815 104.74 82.5459 102.1 87.9158C96.0939 100.13 87.8359 99.9768 75.8241 93.8699C70.0136 90.9157 62.5612 89.2896 59.308 89.2896C72.5209 81.9613 80.3285 67.9154 82.5807 61.8086C90.9889 33.106 79.13 17.2713 67.566 8.37295Z"
            fill="white"
          />
          <path
            id="Vector_2"
            d="M18.4082 74.4888C-3.52919 55.6616 3.05616 29.3457 7.5472 23.3065C16.5293 7.45348 47.218 2.16914 66.6792 27.8359C86.1404 53.5027 72.5019 71.1921 70.3656 73.8852C65.3017 80.2693 44.9725 97.2873 18.4082 74.4888Z"
            fill="#2E428B"
          />
          <rect
            id="Rectangle 171"
            x="1.5"
            y="1.5"
            width="101"
            height="104"
            stroke="white"
            stroke-width="3"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1_10">
          <rect width="1920" height="3649" fill="white" transform="translate(-908 -3431)" />
        </clipPath>
      </defs>
    </svg>
  );

  const fullLogo = (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0.00 0.00 919.00 272.00">
      <path
        fill="#e16f24"
        d="
      M 100.31 0.00
      L 110.06 0.00
      Q 117.31 0.34 124.58 0.47
      C 126.08 0.50 127.37 1.49 129.06 1.49
      Q 193.25 1.50 257.27 1.50
      A 0.62 0.61 -0.5 0 1 257.89 2.10
      C 259.10 74.36 257.69 133.82 258.23 219.00
      C 258.27 225.12 251.88 233.55 248.01 238.01
      C 241.44 245.58 234.27 249.13 224.42 247.58
      C 211.02 245.47 197.93 240.34 185.15 235.40
      C 174.58 231.31 161.31 226.90 149.92 226.95
      A 0.53 0.53 0.0 0 1 149.71 225.94
      Q 152.58 224.73 155.53 222.76
      C 178.24 207.54 194.58 186.18 205.34 161.08
      C 220.14 126.55 216.60 86.73 198.53 54.21
      C 184.97 29.80 161.68 13.37 135.21 5.82
      C 120.11 1.51 101.11 1.94 85.89 5.31
      Q 28.56 18.01 1.22 71.54
      A 0.43 0.43 0.0 0 1 0.53 71.65
      Q 0.22 71.35 0.00 70.68
      L 0.00 59.94
      L 0.21 2.51
      A 1.00 0.99 0.0 0 1 1.21 1.52
      Q 42.79 1.49 84.75 1.50
      Q 88.51 1.50 100.31 0.00
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 862.79 16.13
      Q 863.50 14.35 864.95 14.49
      A 1.33 1.32 82.4 0 1 866.06 15.35
      C 871.88 31.21 877.04 47.46 883.29 63.11
      Q 885.61 68.91 891.11 72.16
      A 0.55 0.55 0.0 0 1 890.84 73.18
      C 886.38 73.22 878.90 74.23 874.70 73.08
      A 0.80 0.80 0.0 0 1 874.55 71.59
      L 876.51 70.62
      A 0.67 0.66 67.1 0 0 876.84 69.80
      L 871.07 53.66
      Q 870.92 53.25 870.48 53.25
      L 851.73 53.25
      A 0.85 0.85 0.0 0 0 850.93 53.82
      Q 849.73 57.16 848.27 64.01
      C 847.05 69.74 850.04 70.89 854.72 71.39
      Q 855.21 71.45 855.66 71.65
      Q 856.98 72.24 855.98 72.97
      Q 855.56 73.27 855.04 73.27
      Q 845.64 73.26 836.26 73.06
      Q 835.61 73.05 835.35 72.89
      A 0.60 0.60 0.0 0 1 835.41 71.82
      C 840.32 69.65 843.22 64.54 845.70 58.44
      Q 854.30 37.31 862.79 16.13
      Z
      M 852.45 50.10
      A 0.33 0.33 0.0 0 0 852.75 50.56
      L 869.54 50.94
      A 0.33 0.33 0.0 0 0 869.86 50.50
      L 861.96 28.46
      A 0.33 0.33 0.0 0 0 861.34 28.45
      L 852.45 50.10
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 570.31 16.85
      L 572.60 14.99
      A 0.55 0.55 0.0 0 1 573.50 15.42
      L 573.50 30.65
      A 0.78 0.78 0.0 0 1 572.97 31.39
      L 571.82 31.77
      A 0.78 0.78 0.0 0 1 570.81 31.14
      Q 568.78 17.51 554.75 19.23
      Q 554.25 19.29 554.25 19.79
      Q 554.26 43.16 554.20 66.50
      C 554.19 69.19 559.02 71.11 561.01 72.01
      A 0.66 0.66 0.0 0 1 560.74 73.27
      C 554.14 73.28 545.12 74.18 538.81 72.83
      A 0.55 0.55 0.0 0 1 538.79 71.75
      C 542.36 70.87 545.65 70.63 545.67 65.94
      Q 545.78 42.84 545.75 19.92
      A 0.98 0.97 -2.5 0 0 544.70 18.96
      C 534.36 19.76 531.91 20.49 528.97 31.08
      A 1.31 1.31 0.0 0 1 526.40 30.75
      L 526.19 16.00
      A 0.94 0.94 0.0 0 1 527.78 15.31
      C 529.69 17.14 531.20 16.98 533.67 16.99
      Q 551.17 17.13 569.69 17.08
      A 1.03 1.02 24.4 0 0 570.31 16.85
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 626.17 19.87
      L 621.40 18.41
      A 0.67 0.67 0.0 0 1 621.59 17.10
      Q 637.29 17.02 653.12 17.23
      C 655.07 17.26 656.62 16.72 657.81 15.29
      A 0.71 0.71 0.0 0 1 659.07 15.66
      Q 659.91 23.20 659.06 30.82
      A 1.26 1.26 0.0 0 1 656.56 30.76
      C 655.88 20.04 646.30 18.31 637.28 19.16
      Q 636.80 19.20 636.72 19.68
      C 635.78 25.25 635.41 35.10 639.91 39.32
      C 643.93 43.09 648.14 42.28 653.10 42.66
      A 1.01 1.01 0.0 0 1 653.90 44.18
      C 653.50 44.88 652.77 45.23 651.92 45.25
      Q 644.68 45.45 637.42 45.56
      A 0.68 0.68 0.0 0 0 636.75 46.24
      L 636.75 70.02
      A 1.28 1.28 0.0 0 0 638.11 71.30
      C 651.03 70.53 654.84 69.82 660.17 57.61
      Q 660.34 57.22 660.72 57.02
      L 661.25 56.74
      A 0.69 0.69 0.0 0 1 662.25 57.48
      L 658.93 74.99
      A 0.85 0.84 30.9 0 1 657.44 75.36
      L 656.08 73.68
      Q 655.74 73.25 655.18 73.25
      L 621.79 73.25
      A 0.70 0.70 0.0 0 1 621.09 72.56
      Q 621.09 71.78 621.87 71.35
      C 625.21 69.48 628.23 71.41 628.24 65.51
      Q 628.27 43.94 628.24 22.67
      A 2.94 2.93 8.6 0 0 626.17 19.87
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 287.16 56.35
      C 287.40 63.72 292.74 71.51 300.54 71.66
      C 311.84 71.86 316.37 58.46 306.95 52.28
      C 296.79 45.60 278.13 36.43 288.74 23.34
      C 295.38 15.15 306.23 13.93 315.79 17.94
      A 1.23 1.23 0.0 0 1 316.54 19.09
      L 316.41 30.86
      Q 316.40 31.44 315.84 31.52
      L 314.07 31.77
      Q 313.33 31.87 313.27 31.13
      C 311.12 7.01 277.80 22.42 299.60 37.22
      C 310.30 44.49 325.61 51.27 316.06 64.96
      C 309.05 74.99 295.79 76.72 285.17 71.81
      A 1.60 1.59 12.6 0 1 284.25 70.37
      L 284.30 56.62
      Q 284.30 55.85 285.06 55.82
      L 286.52 55.75
      Q 287.14 55.72 287.16 56.35
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 459.25 18.42
      C 454.25 19.04 449.98 24.75 452.38 29.84
      C 458.11 42.00 492.72 49.66 472.47 68.12
      Q 461.03 78.54 444.85 71.97
      A 1.75 1.74 -81.6 0 1 443.76 70.49
      Q 443.24 63.99 443.74 57.42
      Q 443.84 56.18 445.03 55.65
      A 1.01 1.01 0.0 0 1 446.44 56.51
      C 446.91 63.77 451.67 70.66 459.17 71.60
      C 470.88 73.07 475.10 59.24 466.05 52.48
      Q 458.67 46.96 451.04 41.72
      C 445.23 37.72 442.53 30.10 447.31 24.24
      Q 458.17 10.94 474.93 18.16
      A 0.99 0.98 8.9 0 1 475.52 18.96
      Q 476.15 24.93 475.26 30.90
      A 1.31 1.31 0.0 0 1 472.68 30.94
      C 471.52 24.42 467.10 17.45 459.25 18.42
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 385.06 22.81
      Q 384.39 46.29 384.86 65.82
      C 384.95 69.42 389.16 70.69 391.75 71.82
      A 0.75 0.75 0.0 0 1 391.45 73.25
      L 370.31 73.25
      A 1.11 0.99 -87.8 0 1 369.33 72.07
      Q 369.34 71.93 369.72 71.62
      C 371.40 70.22 373.89 70.66 376.00 68.33
      Q 376.35 67.95 376.37 67.43
      Q 377.22 45.17 376.38 22.98
      C 376.26 19.72 371.89 19.25 369.71 18.36
      A 0.71 0.71 0.0 0 1 369.98 17.00
      L 390.90 17.00
      Q 392.92 17.00 391.47 18.40
      C 389.83 19.98 385.17 19.17 385.06 22.81
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 749.15 62.26
      A 0.56 0.56 0.0 0 0 750.17 62.28
      Q 760.53 40.28 769.15 17.55
      Q 769.33 17.05 769.86 17.04
      C 774.04 16.93 778.27 17.24 782.34 16.90
      Q 783.78 16.79 784.63 17.16
      A 1.17 1.17 0.0 0 1 784.20 19.40
      C 779.35 19.54 778.00 20.96 778.41 25.90
      Q 780.70 53.87 782.19 65.25
      C 782.77 69.65 786.13 70.55 789.68 71.81
      A 0.73 0.73 0.0 0 1 789.44 73.23
      L 768.08 73.34
      A 0.84 0.84 0.0 0 1 767.49 71.89
      C 768.79 70.66 771.56 70.90 772.80 69.03
      C 774.01 67.21 773.47 64.37 773.28 62.27
      Q 771.78 46.01 770.30 29.79
      A 0.38 0.38 0.0 0 0 769.59 29.63
      Q 759.07 47.44 751.47 66.74
      Q 749.60 71.48 747.43 74.82
      Q 746.18 76.74 745.30 74.62
      L 724.75 25.27
      A 0.27 0.27 0.0 0 0 724.23 25.35
      Q 722.68 38.68 721.56 52.31
      C 721.04 58.63 721.28 68.93 728.55 71.62
      A 0.84 0.84 0.0 0 1 728.26 73.25
      L 708.57 73.25
      A 0.63 0.62 -63.8 0 1 708.19 72.13
      C 719.51 63.40 720.39 38.33 721.33 25.28
      Q 721.52 22.59 720.80 21.32
      C 719.28 18.67 716.86 19.58 714.94 18.04
      A 0.56 0.56 0.0 0 1 715.29 17.04
      L 729.59 16.98
      A 0.78 0.76 78.5 0 1 730.30 17.46
      L 749.15 62.26
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 88.30 27.61
      C 140.23 31.30 181.62 75.51 192.64 124.22
      C 204.92 178.47 163.81 223.66 108.95 218.63
      C 82.79 216.23 56.77 201.36 38.81 182.77
      C 23.34 166.76 12.90 145.53 7.80 123.99
      C 2.79 102.83 4.89 82.43 15.39 63.14
      C 26.55 42.66 48.60 29.61 71.50 27.28
      Q 76.52 26.77 88.30 27.61
      Z"
      />
      <path
        fill="#2d448a"
        d="
      M 399.59 147.95
      L 384.66 147.99
      A 0.70 0.69 11.5 0 0 384.02 148.41
      Q 381.71 153.57 381.53 159.23
      A 2.54 2.53 6.5 0 0 383.59 161.81
      L 387.70 162.61
      A 0.38 0.37 -83.7 0 1 388.00 162.99
      Q 388.00 163.15 388.02 163.35
      A 0.60 0.60 0.0 0 1 387.42 164.00
      L 371.49 164.00
      A 0.57 0.57 0.0 0 1 371.22 162.92
      C 375.25 160.79 377.23 157.99 379.08 153.53
      Q 385.40 138.29 391.37 122.91
      Q 392.73 119.42 394.34 116.71
      A 0.89 0.88 -40.1 0 1 395.93 116.84
      C 401.05 130.22 405.14 144.01 410.93 157.05
      C 412.18 159.87 413.95 161.60 416.52 162.99
      A 0.54 0.54 0.0 0 1 416.27 164.00
      L 403.00 164.00
      A 0.44 0.44 0.0 0 1 402.87 163.14
      C 404.81 162.53 404.73 160.96 404.09 159.28
      Q 402.04 153.90 400.26 148.43
      Q 400.10 147.94 399.59 147.95
      Z
      M 385.19 145.18
      A 0.32 0.32 0.0 0 0 385.48 145.62
      L 398.73 145.92
      A 0.32 0.32 0.0 0 0 399.04 145.49
      L 392.82 127.51
      A 0.32 0.32 0.0 0 0 392.22 127.49
      L 385.19 145.18
      Z"
      />
      <path
        fill="#2d448a"
        d="
      M 797.17 116.56
      A 0.85 0.84 -41.5 0 1 798.72 116.65
      Q 805.83 136.62 813.23 156.98
      Q 814.37 160.13 819.23 162.99
      A 0.42 0.42 0.0 0 1 819.02 163.77
      L 805.72 163.97
      A 0.36 0.36 0.0 0 1 805.48 163.33
      L 807.13 161.93
      A 0.86 0.85 60.2 0 0 807.38 160.99
      L 802.91 148.42
      A 0.86 0.83 79.1 0 0 802.11 147.86
      L 787.39 147.98
      Q 787.08 147.98 786.95 148.26
      Q 784.00 154.47 784.25 158.75
      C 784.45 162.24 787.65 162.08 790.11 162.50
      Q 790.52 162.57 790.66 162.79
      Q 790.86 163.13 790.70 163.65
      A 0.50 0.50 0.0 0 1 790.22 164.00
      L 774.23 164.00
      A 0.51 0.51 0.0 0 1 773.97 163.05
      Q 778.39 160.49 780.58 155.68
      Q 787.31 140.90 793.08 125.74
      Q 794.75 121.36 797.17 116.56
      Z
      M 787.92 145.20
      A 0.33 0.33 0.0 0 0 788.21 145.65
      L 801.46 145.97
      A 0.33 0.33 0.0 0 0 801.78 145.54
      L 795.59 127.71
      A 0.33 0.33 0.0 0 0 794.97 127.69
      L 787.92 145.20
      Z"
      />
      <path
        fill="#2d448a"
        d="
      M 462.44 126.44
      C 471.00 116.47 482.96 116.13 494.93 119.25
      A 1.88 1.87 8.3 0 1 496.33 121.12
      L 496.02 130.13
      A 0.83 0.83 0.0 0 1 494.39 130.34
      Q 491.66 121.03 482.26 119.79
      C 471.79 118.41 464.98 124.05 462.73 134.06
      C 457.81 155.93 480.21 167.81 496.83 153.58
      A 0.58 0.58 0.0 0 1 497.74 154.26
      Q 497.19 155.46 495.99 156.49
      C 487.84 163.41 476.78 168.08 466.70 162.57
      C 453.06 155.11 453.16 137.24 462.44 126.44
      Z"
      />
      <path
        fill="#2d448a"
        d="
      M 642.9853 126.6024
      A 25.31 23.01 -35.5 0 1 635.7420 160.0328
      A 25.31 23.01 -35.5 0 1 601.7747 155.9976
      A 25.31 23.01 -35.5 0 1 609.0180 122.5672
      A 25.31 23.01 -35.5 0 1 642.9853 126.6024
      Z
      M 632.2256 160.3842
      A 21.51 17.81 62.7 0 0 638.1863 133.1015
      A 21.51 17.81 62.7 0 0 612.4944 122.1558
      A 21.51 17.81 62.7 0 0 606.5337 149.4385
      A 21.51 17.81 62.7 0 0 632.2256 160.3842
      Z"
      />
      <path
        fill="#2d448a"
        d="
      M 324.38 152.69
      A 0.32 0.32 0.0 0 0 324.95 152.50
      Q 325.41 139.97 323.55 127.54
      Q 322.76 122.25 318.22 119.49
      A 0.50 0.50 0.0 0 1 318.47 118.57
      L 334.01 118.34
      A 0.60 0.60 0.0 0 1 334.34 119.44
      C 329.13 122.75 328.36 128.12 327.83 134.36
      C 327.01 144.18 327.47 154.58 327.51 163.99
      Q 327.53 167.79 325.22 164.77
      L 294.54 124.71
      A 0.46 0.46 0.0 0 0 293.71 125.00
      Q 293.80 133.86 294.07 142.75
      C 294.30 150.60 294.62 159.35 300.55 162.84
      A 0.62 0.62 0.0 0 1 300.24 164.00
      L 285.05 164.00
      A 0.43 0.43 0.0 0 1 284.77 163.25
      Q 290.21 158.61 290.79 151.31
      Q 291.93 136.88 291.38 122.39
      Q 291.36 121.83 290.84 121.62
      L 285.81 119.63
      A 0.59 0.58 -34.1 0 1 286.03 118.50
      L 297.78 118.50
      A 1.07 1.07 0.0 0 1 298.63 118.92
      L 324.38 152.69
      Z"
      />
      <path
        fill="#2d448a"
        d="
      M 544.20 156.78
      C 544.48 145.97 544.03 135.25 544.24 124.51
      C 544.32 120.86 541.12 120.62 538.54 119.72
      A 0.62 0.62 0.0 0 1 538.74 118.51
      L 556.27 118.47
      A 0.62 0.62 0.0 0 1 556.74 119.49
      C 555.40 121.09 551.27 120.11 551.26 123.25
      Q 551.23 140.99 551.26 158.67
      A 2.78 2.78 0.0 0 0 552.89 161.20
      L 556.47 162.82
      A 0.62 0.62 0.0 0 1 556.21 164.00
      L 539.00 164.00
      A 0.53 0.52 -83.4 0 1 538.49 163.35
      Q 538.59 162.91 538.86 162.61
      Q 539.08 162.36 539.59 162.30
      Q 544.07 161.73 544.20 156.78
      Z"
      />
      <path
        fill="#2d448a"
        d="
      M 696.56 124.81
      Q 696.55 138.82 697.84 152.98
      Q 698.43 159.46 703.34 162.97
      A 0.57 0.57 0.0 0 1 703.01 164.00
      L 687.75 164.00
      A 0.51 0.51 0.0 0 1 687.44 163.08
      Q 692.24 159.51 693.25 153.24
      Q 694.93 142.78 693.98 122.88
      Q 693.95 122.30 693.54 121.88
      Q 691.95 120.26 689.57 120.25
      A 1.13 1.09 -21.1 0 1 688.81 119.93
      L 688.37 119.50
      A 0.55 0.55 0.0 0 1 688.75 118.57
      L 700.37 118.34
      Q 700.86 118.33 701.16 118.72
      L 727.11 152.67
      Q 727.66 153.39 727.70 152.48
      Q 728.15 141.07 726.90 129.25
      Q 726.21 122.74 720.76 119.31
      A 0.40 0.40 0.0 0 1 720.97 118.57
      L 736.28 118.32
      A 0.72 0.71 26.3 0 1 736.72 119.61
      Q 731.63 123.36 731.11 130.01
      Q 729.76 147.36 730.36 165.06
      Q 730.40 166.08 729.42 165.79
      Q 728.63 165.55 727.78 164.46
      Q 712.41 144.79 697.25 124.58
      A 0.38 0.38 0.0 0 0 696.56 124.81
      Z"
      />
      <path
        fill="#2d448a"
        d="
      M 871.09 162.28
      C 879.42 162.81 887.02 160.87 889.07 151.66
      A 0.96 0.95 89.0 0 1 889.75 150.95
      Q 891.00 150.61 890.81 151.71
      Q 889.56 158.61 888.38 165.51
      Q 888.24 166.28 887.61 165.81
      L 885.52 164.26
      A 1.33 1.31 -26.3 0 0 884.73 164.00
      L 858.67 164.00
      A 0.70 0.70 0.0 0 1 858.42 162.64
      L 862.39 161.12
      A 1.74 1.74 0.0 0 0 863.50 159.50
      L 863.51 122.35
      A 0.85 0.85 0.0 0 0 862.97 121.56
      L 858.28 119.72
      A 0.60 0.60 0.0 0 1 858.49 118.56
      L 875.32 118.36
      A 0.84 0.84 0.0 0 1 875.59 120.00
      L 871.69 121.28
      A 1.30 1.27 -88.3 0 0 870.89 122.05
      Q 870.51 123.07 870.50 124.00
      Q 870.26 140.37 870.58 161.75
      Q 870.59 162.25 871.09 162.28
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 789.05 190.84
      C 796.06 179.61 801.90 194.03 807.98 186.70
      A 0.53 0.53 0.0 0 1 808.90 187.18
      C 806.83 194.92 798.65 190.36 794.13 189.13
      Q 793.67 189.01 793.27 189.28
      L 789.87 191.63
      A 0.58 0.58 0.0 0 1 789.05 190.84
      Z"
      />
      <path
        fill="#2d448a"
        d="
      M 0.00 235.40
      L 0.00 213.70
      L 0.36 191.77
      A 0.47 0.46 30.7 0 1 1.23 191.55
      C 16.71 219.30 44.03 238.72 76.45 241.03
      Q 77.11 241.08 76.78 241.66
      Q 71.10 251.69 67.15 262.33
      C 66.12 265.10 66.53 266.71 67.80 269.18
      A 1.33 1.33 0.0 0 1 66.61 271.11
      L 1.94 270.88
      A 1.29 1.29 0.0 0 1 0.66 269.62
      L 0.00 235.40
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 498.99 242.16
      L 503.55 243.24
      A 0.78 0.59 24.1 0 1 504.13 244.28
      Q 503.93 244.49 503.18 244.52
      Q 495.49 244.80 487.62 244.76
      A 0.66 0.66 0.0 0 1 487.32 243.51
      Q 492.65 240.80 494.98 234.88
      Q 501.29 218.91 507.73 202.99
      Q 509.00 199.87 510.71 196.71
      A 0.78 0.78 0.0 0 1 512.13 196.81
      Q 519.19 215.68 526.04 234.95
      C 527.87 240.09 531.28 245.31 537.51 241.82
      A 1.84 1.83 -14.4 0 0 538.45 240.24
      Q 538.58 223.94 538.81 207.75
      Q 538.84 206.10 538.30 202.14
      Q 538.23 201.62 537.74 201.44
      L 533.04 199.73
      A 0.64 0.63 -34.9 0 1 533.26 198.50
      L 551.24 198.50
      A 0.77 0.77 0.0 0 1 551.48 200.01
      L 547.08 201.44
      Q 546.60 201.60 546.38 202.06
      Q 545.81 203.28 545.79 204.68
      C 545.51 218.44 546.50 229.09 545.71 241.42
      A 1.52 1.52 0.0 0 0 547.28 243.04
      C 554.05 242.80 559.25 242.73 562.71 236.15
      C 563.31 235.01 563.62 232.73 564.84 231.56
      A 0.77 0.77 0.0 0 1 566.13 232.27
      L 563.36 246.03
      A 0.64 0.64 0.0 0 1 562.36 246.43
      L 560.29 244.95
      A 1.08 1.03 -26.2 0 0 559.68 244.76
      L 519.66 244.57
      A 0.46 0.46 0.0 0 1 519.34 243.79
      L 520.85 242.27
      Q 521.27 241.85 521.07 241.29
      L 516.60 229.09
      Q 516.42 228.57 515.87 228.56
      L 500.69 228.35
      Q 500.26 228.34 500.09 228.74
      Q 497.68 234.38 497.67 240.50
      A 1.71 1.70 6.6 0 0 498.99 242.16
      Z
      M 501.20 225.65
      A 0.31 0.31 0.0 0 0 501.48 226.08
      L 515.18 226.42
      A 0.31 0.31 0.0 0 0 515.48 226.00
      L 509.05 208.45
      A 0.31 0.31 0.0 0 0 508.48 208.44
      L 501.20 225.65
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 348.75 222.75
      L 348.75 241.94
      Q 348.75 242.32 349.13 242.40
      Q 363.26 245.23 367.54 232.26
      Q 367.76 231.58 368.14 231.39
      Q 368.67 231.14 369.19 231.67
      A 0.76 0.76 0.0 0 1 369.40 232.34
      L 366.78 245.91
      A 0.77 0.77 0.0 0 1 365.49 246.32
      L 364.25 245.15
      Q 363.89 244.80 363.39 244.80
      Q 351.07 244.66 338.78 244.68
      C 338.03 244.68 337.05 244.93 336.25 244.48
      A 0.83 0.83 0.0 0 1 336.46 242.95
      L 341.07 241.82
      A 0.90 0.89 83.0 0 0 341.74 240.95
      L 341.66 202.22
      Q 341.65 201.52 340.97 201.35
      L 336.51 200.29
      A 0.57 0.57 0.0 0 1 336.07 199.79
      L 336.01 199.21
      A 0.62 0.61 87.0 0 1 336.62 198.53
      L 364.51 198.48
      A 1.03 1.00 17.6 0 0 365.33 198.07
      L 366.30 196.77
      A 0.46 0.45 -27.1 0 1 367.12 197.03
      L 367.30 209.97
      A 1.13 1.13 0.0 0 1 365.08 210.28
      C 362.65 201.18 358.08 199.79 349.14 200.28
      Q 348.69 200.31 348.62 200.75
      C 347.69 206.72 347.27 214.33 352.71 218.04
      C 355.27 219.78 358.96 219.55 362.05 219.50
      Q 362.61 219.49 362.73 220.04
      C 362.98 221.13 362.10 221.74 361.08 221.81
      Q 355.25 222.22 349.40 222.11
      Q 348.75 222.10 348.75 222.75
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 712.06 228.52
      L 696.86 228.38
      A 0.55 0.54 10.0 0 0 696.35 228.73
      Q 694.36 234.05 693.70 239.71
      A 2.29 2.28 -81.5 0 0 695.55 242.22
      L 699.77 243.01
      A 0.79 0.78 36.6 0 1 699.99 244.48
      Q 698.98 245.01 697.24 244.89
      Q 691.00 244.48 683.93 244.78
      A 0.60 0.59 -61.1 0 1 683.61 243.67
      C 688.94 240.59 690.19 236.68 692.45 231.23
      Q 699.48 214.32 706.21 197.27
      A 1.09 1.09 0.0 0 1 708.16 197.10
      Q 708.51 197.68 708.84 198.60
      Q 715.94 217.95 723.50 237.12
      Q 725.35 241.81 729.59 244.05
      A 0.38 0.37 -31.0 0 1 729.41 244.75
      L 715.99 244.75
      A 0.55 0.55 0.0 0 1 715.59 243.83
      L 717.12 242.16
      A 0.85 0.83 56.6 0 0 717.29 241.28
      L 712.55 228.86
      Q 712.42 228.52 712.06 228.52
      Z
      M 697.48 225.61
      A 0.32 0.32 0.0 0 0 697.77 226.06
      L 711.08 226.45
      A 0.32 0.32 0.0 0 0 711.39 226.03
      L 705.26 208.26
      A 0.32 0.32 0.0 0 0 704.66 208.24
      L 697.48 225.61
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 831.25 201.40
      Q 829.56 200.77 827.27 200.20
      Q 826.41 199.98 826.49 199.67
      A 1.52 1.52 0.0 0 1 827.96 198.54
      Q 841.63 198.47 854.50 198.51
      C 855.66 198.51 856.55 198.01 856.77 196.87
      A 0.74 0.74 0.0 0 1 858.23 197.02
      L 858.01 209.84
      A 0.91 0.90 -7.3 0 1 857.34 210.70
      Q 856.50 210.94 856.03 210.45
      Q 855.76 210.17 855.64 209.48
      C 854.27 201.24 847.00 199.53 839.82 200.38
      Q 839.35 200.43 839.30 200.90
      C 837.85 212.93 839.15 219.96 852.89 219.46
      Q 853.35 219.44 853.43 219.90
      Q 853.80 222.06 851.75 222.01
      Q 845.99 221.87 840.23 222.06
      A 0.75 0.75 0.0 0 0 839.50 222.81
      L 839.50 242.00
      Q 839.50 242.58 840.08 242.65
      C 847.76 243.50 855.77 241.91 857.80 233.15
      A 1.11 1.11 0.0 0 1 858.19 232.51
      Q 860.86 230.24 860.30 233.26
      Q 859.06 239.82 857.78 246.38
      A 0.50 0.50 0.0 0 1 856.98 246.69
      L 854.53 244.85
      A 0.54 0.53 62.3 0 0 854.22 244.75
      L 827.53 244.75
      A 0.97 0.96 75.0 0 1 826.69 244.26
      Q 826.11 243.21 827.19 242.95
      Q 829.43 242.40 831.00 241.96
      A 1.84 1.84 0.0 0 0 832.34 240.19
      L 832.24 202.83
      A 1.53 1.52 -79.8 0 0 831.25 201.40
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 599.82 223.64
      L 599.92 240.22
      Q 599.92 240.86 600.45 241.23
      Q 602.44 242.63 604.82 243.01
      A 0.87 0.86 49.7 0 1 604.68 244.73
      L 587.36 244.66
      A 0.49 0.49 0.0 0 1 587.02 243.82
      Q 588.45 242.40 590.56 242.30
      A 2.02 2.02 0.0 0 0 592.48 240.35
      Q 593.00 224.45 592.68 208.00
      Q 592.61 204.33 592.29 202.13
      Q 592.21 201.60 591.72 201.40
      Q 590.02 200.70 588.27 200.43
      Q 586.62 200.17 587.69 198.98
      A 1.44 1.43 -68.9 0 1 588.76 198.50
      L 615.39 198.50
      Q 615.79 198.50 616.11 198.27
      L 617.27 197.44
      Q 618.00 196.91 618.00 197.81
      L 618.00 209.96
      Q 618.00 210.41 617.64 210.68
      Q 616.53 211.53 615.63 210.21
      A 1.15 1.11 26.7 0 1 615.43 209.64
      C 615.04 201.19 607.06 200.02 600.39 200.26
      A 0.89 0.89 0.0 0 0 599.53 201.06
      C 598.87 207.04 597.90 218.45 606.04 219.85
      Q 609.49 220.44 612.86 220.67
      A 0.92 0.92 0.0 0 1 613.59 222.05
      Q 613.29 222.57 612.41 222.68
      Q 606.43 223.43 600.41 223.08
      Q 599.81 223.04 599.82 223.64
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 416.65 245.15
      Q 423.18 249.56 429.74 254.04
      C 432.42 255.86 436.68 252.64 439.14 250.14
      A 0.45 0.45 0.0 0 1 439.88 250.29
      Q 440.12 250.95 439.62 251.62
      C 435.99 256.52 430.43 262.58 423.87 257.64
      C 416.22 251.88 409.91 246.09 404.04 244.42
      A 1.07 1.06 -55.3 0 0 403.12 244.59
      L 396.74 249.23
      A 0.52 0.52 0.0 0 1 395.97 248.58
      Q 397.33 245.77 399.88 244.02
      Q 400.41 243.66 399.84 243.35
      C 375.77 230.32 391.24 196.97 414.98 197.67
      C 431.66 198.17 442.58 214.10 435.25 229.56
      C 432.00 236.43 424.42 243.29 416.79 244.52
      A 0.35 0.35 0.0 0 0 416.65 245.15
      Z
      M 422.7597 240.7075
      A 21.57 17.85 61.9 0 0 428.3460 213.2724
      A 21.57 17.85 61.9 0 0 402.4403 202.6525
      A 21.57 17.85 61.9 0 0 396.8540 230.0876
      A 21.57 17.85 61.9 0 0 422.7597 240.7075
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 648.19 207.19
      C 657.30 196.48 668.69 196.22 681.53 199.54
      A 1.41 1.40 7.2 0 1 682.59 200.90
      L 682.66 210.11
      A 1.22 1.22 0.0 0 1 680.26 210.46
      C 677.86 202.11 671.20 198.78 662.89 199.95
      C 641.09 203.03 644.37 240.81 666.52 240.64
      C 672.68 240.59 678.84 237.48 683.65 233.78
      A 0.35 0.34 -16.6 0 1 684.21 234.08
      C 683.88 237.82 673.51 242.95 670.42 244.04
      C 656.92 248.79 643.91 241.77 641.81 227.42
      Q 640.22 216.56 648.19 207.19
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 749.80 246.99
      A 0.74 0.74 0.0 0 0 749.19 246.00
      Q 733.60 244.15 730.40 228.82
      C 727.11 213.02 740.32 197.03 756.51 197.65
      Q 762.99 197.89 769.48 199.57
      A 1.67 1.65 -80.5 0 1 770.71 201.31
      Q 770.40 205.39 770.28 209.92
      Q 770.23 211.52 769.01 211.07
      A 0.86 0.85 3.7 0 1 768.50 210.50
      C 766.72 203.65 762.45 200.35 755.42 199.74
      C 730.89 197.61 729.30 238.76 753.76 240.68
      C 760.38 241.19 765.90 238.11 771.21 234.28
      A 0.65 0.65 0.0 0 1 772.07 235.25
      Q 764.19 243.76 752.75 245.61
      Q 752.18 245.71 751.78 245.94
      Q 751.21 246.28 750.98 246.60
      A 1.04 1.03 -74.0 0 0 751.87 248.22
      C 766.64 247.58 758.20 262.21 747.00 256.42
      A 0.59 0.59 0.0 0 1 747.01 255.37
      L 747.30 255.24
      Q 747.73 255.03 748.18 255.20
      Q 751.62 256.50 754.85 254.82
      A 1.18 1.17 84.4 0 0 755.42 254.12
      C 756.46 250.55 751.57 250.44 749.40 250.18
      A 0.57 0.57 0.0 0 1 748.93 249.42
      L 749.80 246.99
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 820.3217 207.1491
      A 25.66 23.20 -34.6 0 1 812.3740 240.8168
      A 25.66 23.20 -34.6 0 1 778.0783 236.2909
      A 25.66 23.20 -34.6 0 1 786.0260 202.6232
      A 25.66 23.20 -34.6 0 1 820.3217 207.1491
      Z
      M 809.4335 240.7104
      A 21.60 17.92 61.6 0 0 814.9233 213.1868
      A 21.60 17.92 61.6 0 0 788.8865 202.7096
      A 21.60 17.92 61.6 0 0 783.3967 230.2332
      A 21.60 17.92 61.6 0 0 809.4335 240.7104
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 885.14 236.44
      C 888.25 223.26 853.03 219.79 866.18 204.14
      Q 873.09 195.92 885.51 198.63
      C 890.36 199.68 889.14 205.64 888.97 209.44
      Q 888.93 210.45 888.50 210.80
      Q 887.96 211.26 887.08 210.80
      A 0.92 0.90 -79.9 0 1 886.61 210.11
      C 885.88 204.27 881.24 198.97 875.03 200.06
      Q 870.86 200.79 869.28 205.05
      C 865.05 216.44 898.52 221.06 889.78 235.96
      Q 882.19 248.88 865.93 244.63
      Q 864.12 244.15 863.00 243.44
      A 1.09 1.06 16.7 0 1 862.50 242.54
      L 862.50 231.03
      Q 862.50 230.39 863.14 230.33
      L 864.15 230.22
      A 0.54 0.53 -4.1 0 1 864.74 230.72
      C 865.28 238.40 871.65 246.26 879.98 242.44
      Q 884.18 240.51 885.14 236.44
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 288.79 241.98
      Q 289.94 241.65 289.95 240.46
      L 290.19 202.94
      A 1.17 1.16 -77.8 0 0 289.51 201.88
      L 284.60 199.71
      A 0.56 0.53 13.1 0 1 284.28 199.22
      L 284.28 198.93
      Q 284.28 198.49 284.72 198.49
      Q 298.45 198.59 305.69 198.41
      C 312.21 198.25 320.55 198.21 325.78 201.43
      C 337.02 208.37 334.22 225.56 327.16 234.38
      C 316.72 247.40 299.78 245.18 284.83 244.63
      A 0.75 0.74 -51.8 0 1 284.66 243.17
      L 288.79 241.98
      Z
      M 296.87 207.19
      L 296.97 235.51
      A 6.72 6.72 0.0 0 0 303.71 242.21
      L 309.83 242.19
      A 19.24 16.48 89.8 0 0 326.25 222.89
      L 326.23 219.61
      A 19.24 16.48 89.8 0 0 309.69 200.43
      L 303.57 200.45
      A 6.72 6.72 0.0 0 0 296.87 207.19
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 572.46 235.87
      Q 572.56 222.31 572.47 208.71
      C 572.44 204.25 573.09 200.79 567.95 200.34
      A 0.97 0.95 77.8 0 1 567.18 199.83
      L 566.85 199.21
      A 0.42 0.41 -14.7 0 1 567.21 198.60
      L 584.45 198.43
      Q 585.29 198.42 585.02 199.22
      L 584.67 200.21
      A 0.78 0.78 0.0 0 1 583.87 200.73
      Q 579.80 200.33 579.71 204.49
      Q 579.29 223.38 579.85 238.76
      C 579.99 242.50 582.05 241.69 584.56 242.84
      Q 585.26 243.16 585.42 243.55
      Q 585.91 244.73 584.62 244.74
      Q 576.03 244.78 567.57 244.51
      Q 566.84 244.48 566.82 244.32
      A 1.66 1.66 0.0 0 1 568.27 242.51
      C 572.88 241.96 572.42 240.05 572.46 235.87
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 488.85 199.61
      C 473.68 210.10 491.39 238.27 471.96 244.41
      C 460.94 247.90 445.32 245.40 445.29 230.74
      Q 445.26 217.87 445.20 204.98
      Q 445.17 200.38 440.88 200.50
      A 0.48 0.46 60.6 0 1 440.62 200.42
      L 439.37 199.57
      A 0.55 0.55 0.0 0 1 439.67 198.57
      L 457.66 198.47
      Q 458.11 198.46 458.22 198.90
      Q 458.40 199.62 457.88 200.02
      A 0.37 0.33 14.9 0 1 457.74 200.09
      L 453.03 201.66
      A 0.85 0.83 80.9 0 0 452.46 202.46
      Q 452.63 216.52 452.28 230.48
      Q 451.98 242.22 463.52 243.50
      C 471.74 244.40 478.51 240.68 479.03 231.75
      Q 479.92 216.78 477.05 203.95
      A 0.63 0.59 16.5 0 0 476.85 203.61
      L 472.36 199.62
      A 0.61 0.61 0.0 0 1 472.76 198.56
      L 488.50 198.47
      A 0.63 0.62 -62.3 0 1 488.85 199.61
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 624.94 239.19
      Q 625.11 214.21 624.98 204.00
      C 624.95 201.40 621.67 200.68 619.75 199.90
      A 0.39 0.39 0.0 0 1 619.50 199.52
      Q 619.50 199.35 619.48 199.15
      A 0.60 0.60 0.0 0 1 620.08 198.50
      L 637.27 198.50
      Q 637.84 198.50 637.76 199.06
      C 637.44 201.12 633.95 200.55 632.41 201.99
      A 1.31 1.28 69.1 0 0 632.00 202.94
      L 632.00 239.07
      A 2.95 2.95 0.0 0 0 633.65 241.72
      L 637.79 243.74
      A 0.53 0.53 0.0 0 1 637.56 244.75
      L 620.00 244.75
      A 0.79 0.79 0.0 0 1 619.22 244.08
      Q 619.16 243.71 619.43 243.40
      Q 619.61 243.18 620.00 243.08
      Q 621.77 242.61 623.47 241.92
      Q 623.93 241.74 624.17 241.31
      Q 624.93 239.95 624.94 239.19
      Z"
      />
      <path
        fill="#2d448a"
        d="
      M 183.50 270.69
      Q 183.18 270.54 183.00 270.54
      Q 141.79 270.96 100.59 270.75
      C 94.12 270.71 83.76 271.31 75.28 270.77
      Q 74.79 270.74 74.43 271.07
      Q 74.12 271.36 73.83 271.43
      A 0.98 0.98 0.0 0 1 72.74 270.01
      Q 78.95 258.41 87.35 249.07
      C 97.70 237.56 108.41 241.13 123.12 245.65
      Q 152.41 254.66 181.00 265.76
      C 185.49 267.50 189.80 268.10 193.78 270.89
      A 0.44 0.43 62.9 0 1 193.53 271.68
      L 182.40 271.43
      Q 181.80 271.42 182.33 271.13
      Q 182.85 270.85 183.46 270.87
      A 0.10 0.09 58.6 0 0 183.50 270.69
      Z"
      />
      <path
        fill="#e16f24"
        d="
      M 257.56 270.56
      C 251.86 271.36 246.32 269.72 240.77 271.07
      A 0.56 0.56 0.0 0 1 240.26 270.11
      C 248.32 262.78 252.43 254.31 257.59 245.08
      A 0.35 0.35 0.0 0 1 258.25 245.25
      L 258.25 269.77
      Q 258.25 270.47 257.56 270.56
      Z"
      />
    </svg>
  );

  return (
    <Link
      component={RouterLink}
      href="/"
      color="inherit"
      aria-label="go to homepage"
      sx={{ lineHeight: 0 }}
    >
      <Box
        sx={{
          width: single ? 64 : 75,
          lineHeight: 0,
          cursor: 'pointer',
          display: 'inline-flex',
          ...sx,
        }}
      >
        {single ? singleLogo : fullLogo}
      </Box>
    </Link>
  );
}

Logo.propTypes = {
  single: PropTypes.bool,
  sx: PropTypes.object,
};

export default memo(Logo);
